import { InternalTaskCustomField, PreviewTask } from "@jugl-web/rest-api/tasks";
import {
  PILL_BASE_BG_COLOR,
  PILL_BASE_TEXT_COLOR,
} from "@jugl-web/ui-components/cross-platform/tasks/TaskCardPill";
import format from "date-fns/format";
import { TaskCardField } from "./TaskCard";

export const adaptCustomFieldToTaskCardField = (
  customField: InternalTaskCustomField,
  value: string,
  dateLocale?: Locale
): TaskCardField | null => {
  // Format value if necessary
  if (value === "") {
    return null;
  }
  if (customField.type === "date" && value) {
    value = format(new Date(value), "dd MMM, yyyy", { locale: dateLocale });
  } else if (customField.type === "dropdown") {
    const dropdownValue = customField.values?.find(
      (v) => v.id === value
    )?.value;

    if (!dropdownValue) {
      return null;
    }

    value = dropdownValue;
  }

  return {
    id: customField.id,
    text: `${customField.name}: ${value}`,
    textColor: PILL_BASE_TEXT_COLOR,
    backgroundColor: PILL_BASE_BG_COLOR,
  };
};

export const adaptCustomFieldsToTaskCardFields = (
  customFields: PreviewTask["custom_fields"],
  getCustomFieldById: (id: string) => InternalTaskCustomField | undefined,
  dateLocale?: Locale
): TaskCardField[] => {
  if (!customFields) {
    return [];
  }

  const matchingCustomFields = Object.keys(customFields).reduce<
    InternalTaskCustomField[]
  >((acc, customFieldId) => {
    const customField = getCustomFieldById(customFieldId);

    if (!customField || !customField.isShownInCard) {
      return acc;
    }

    return [...acc, customField];
  }, []);

  return matchingCustomFields
    .sort((a, b) => a.order - b.order)
    .reduce<TaskCardField[]>((acc, customField) => {
      const taskCardField = adaptCustomFieldToTaskCardField(
        customField,
        customFields[customField.id],
        dateLocale
      );

      if (!taskCardField) {
        return acc;
      }

      return [...acc, taskCardField];
    }, []);
};
